import { render } from "./WorkWithUs.vue?vue&type=template&id=ffd76bdc&scoped=true"
import script from "./WorkWithUs.vue?vue&type=script&lang=js"
export * from "./WorkWithUs.vue?vue&type=script&lang=js"

import "./WorkWithUs.vue?vue&type=style&index=0&id=ffd76bdc&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/1_bm_dev/bubblemaps-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd76bdc"]])

export default __exports__